<form #f="ngForm" (ngSubmit)="guardarArticulo(f)" class="card p-4 shadow">
  <!-- Clave -->
  <div class="form-group">
    <label>Clave (ej. 001)</label>
    <input class="form-control" name="clave" [(ngModel)]="articulo.clave" required maxlength="20"
           (input)="articulo.clave = articulo.clave?.toUpperCase()?.trim()" maxlength="4" />
    <small *ngIf="f.submitted && f.controls['clave']?.invalid" class="text-danger">Obligatorio</small>
  </div>

  <!-- Combo Partidas (opcional, puede ir null) -->
  <div class="form-group">
    <label>Partida (opcional)</label>
    <select class="form-control" name="id_partidas" [(ngModel)]="articulo.id_partidas" required>
      <!-- <option [ngValue]="null">-- Sin partida --</option> -->
      <option *ngFor="let p of partidas" [ngValue]="p.id">
        {{ p.clave }} - {{ p.descripcion }}
      </option>
    </select>
  </div>

  <!-- Descripción -->
  <div class="form-group">
    <label>Descripción</label>
    <input class="form-control" name="descripcion" [(ngModel)]="articulo.descripcion" required>
    <small *ngIf="f.submitted && f.controls['descripcion']?.invalid" class="text-danger">Obligatorio</small>
  </div>


  <!-- Unidad de medida -->
  <!-- <div class="form-group">
    <label>Unidad de medida</label>
    <input class="form-control" name="unidad_medida" [(ngModel)]="articulo.unidad_medida" required
           (input)="articulo.unidad_medida = articulo.unidad_medida?.toUpperCase()?.trim()" maxlength="5"/>
    <small *ngIf="f.submitted && f.controls['unidad_medida']?.invalid" class="text-danger">Obligatorio</small>
  </div> -->

  <!-- Activo / Básico -->

  <!-- <div class="form-row">
    <div class="form-group col-md-3">
      <div class="form-check">
        <input class="form-check-input" type="checkbox" id="esActivo" name="esActivo" [(ngModel)]="articulo.esActivo">
        <label class="form-check-label" for="esActivo">Activo</label>
      </div>
    </div> -->
    <!-- <div class="form-group col-md-3">
      <div class="form-check">
        <input class="form-check-input" type="checkbox" id="esBasico" name="esBasico" [(ngModel)]="articulo.esBasico">
        <label class="form-check-label" for="esBasico">Básico</label>
      </div>
    </div> -->
  <!-- </div> -->

  <button class="btn btn-primary btn-sm w-25 m-auto" type="submit" [disabled]="loading || f.invalid">
    {{ loading ? 'Guardando…' : 'Guardar artículo' }}
  </button>
</form>